/**
 * Created with IntelliJ IDEA.
 * User: shlomif
 * Date: 9/29/13
 * Time: 5:30 PM
 * To change this template use File | Settings | File Templates.
 */
define(function(require){
    "use strict";

    var BaseModel = require("models/BaseModel");

    var GoogleAnalyticsProfileUrlModel = BaseModel.extend({
        defaults: {
            url: "",
            time: 0
        }
    });

    return GoogleAnalyticsProfileUrlModel;
});